export const regExp = {
  email: /.+@.+\..+/,
}

export const isEmail = (email) => regExp.email.test(email)
